export default __webpack_public_path__ + "static/tplo-vid-46049fffc36c23e72544750126d4bf2a.png";